/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceIdRegexQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceIdRegexQueryOperator");
    }

    getFixupPrototypeFunction() { return ResourceIdRegexQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ResourceIdRegexQueryOperator>): ResourceIdRegexQueryOperator {
        let obj = Object.assign(new ResourceIdRegexQueryOperator(), model);
        ResourceIdRegexQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceIdRegexQueryOperator>): ResourceIdRegexQueryOperator {
        if (!model) return null;
        return ResourceIdRegexQueryOperator.newInstance(<ResourceIdRegexQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceIdRegexQueryOperator) {
        if (!obj) return;

        models.ResourceIdRegexQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceIdRegexQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceIdRegexQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.resource_id_regex) {
            models.Regex.fixupPrototype(this.resource_id_regex);
        }
    }

    /**
     * Resource ID by regex match
     */
    resource_id_regex: models.Regex;

}
